import { Link } from "react-router-dom";

function Drogin() {
  return (
    <div className="login-container" style={{ background: "url('/assets/doctor-bg.jpg') no-repeat center center/cover" }}>

      <div className="login-card">

        <h2 className="login-title">🩺 Doctor Login</h2>
        <p className="login-subtitle">Access your doctor dashboard</p>

        <form>

          <div className="mb-3">
            <label className="form-label">Email</label>
            <input 
              type="email" 
              className="form-control" 
              placeholder="Enter your email" 
            />
          </div>

          <div className="mb-3">
            <label className="form-label">Password</label>
            <input 
              type="password" 
              className="form-control" 
              placeholder="Enter your password" 
            />
          </div>

          <div className="d-flex justify-content-between mb-3">
            <div>
              <input type="checkbox" /> Remember me
            </div>
            <a href="#" className="forgot-link">Forgot password?</a>
          </div>

          <button className="btn btn-success w-100">
            Login as Doctor
          </button>

        </form>

        <p className="signup-text mt-3">
          Don't have an account? 
          <Link to="/Drsignup" className="fw-bold text-primary ms-1">
            Register Doctor
          </Link>
        </p>

        <p className="text-center mt-2">
          <Link to="/" className="text-decoration-none">
            ← Back to Home
          </Link>
        </p>

      </div>

    </div>
  );
}

export default Drogin;